import { RouteObject, Outlet } from "react-router-dom";
import ProductDetailsMenu from "src/components/ProductDetailsMenu";
import { Matches } from "src/constants/matches";
import { Paths } from "src/constants/paths";
import MasonryLayoutProvider from "src/context/MasonryLayoutProvider";
import MedicationsDrawerProvider from "src/context/drawers/MedicationsDrawerProvider";
import PricesDrawerProvider from "src/context/drawers/PricesDrawerProvider/PricesDrawerProvider";
import { questionOptionsLoader } from "src/loaders/questionOptionsLoader";
import { questionsLoader } from "src/loaders/questionsLoader";
import Employee from "src/pages/Employee";
import Employees from "src/pages/Employees";
import Organization from "src/pages/Organization";
import PriceDetails from "src/pages/PriceDetails";
import ProductMedications from "src/pages/ProductMedications";
import ProductPrices from "src/pages/ProductPrices";
import Products from "src/pages/Products";
import QuestionOptions from "src/pages/QuestionOptions";
import Questions from "src/pages/Questions";
import { intakesPath } from "./productIntakes";
import { productsLoader } from "src/loaders/productsLoaders";
import { productLoader } from "src/loaders/productLoader";
import { medicationsLoader } from "src/loaders/medicationsLoader";
import { medicationLoader } from "src/loaders/medicationLoader";
import { priceLoader } from "src/loaders/priceLoader";
import { pricesLoader } from "src/loaders/pricesLoader";
import { employeeLoader } from "src/loaders/employeeLoader";
import { experimentsLoader } from "src/loaders/experimentsLoader";
import Experiments from "src/pages/Experiments";
import { experimentVariantsLoader } from "src/loaders/experimentVariants";
import ExperimentVariants from "src/pages/ExperimentVariants";
import { experimentResultsLoader } from "src/loaders/experimentResults";
import ExperimentResults from "src/pages/ExperimentResults";
import ItemsSelectionProvider from "src/context/ItemsSelectionProvider";
import ExperimentsDrawerProvider from "src/context/drawers/ExperimentsDrawerProvider";
import ProductMedicationDetails from "src/pages/ProductMedicationDetails";
import ProductsDrawerProvider from "src/context/drawers/ProductsDrawerProvider";
import ProvidersAvailability from "src/pages/ProvidersAvailability";
import ProviderAvailabilityDetail from "src/pages/ProviderAvailabilityDetail";

export const organizationPaths: RouteObject[] = [
  {
    path: "organization",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Organization />,
      },
      {
        path: "experiments",
        children: [
          {
            index: true,
            element: (
              <ExperimentsDrawerProvider>
                <Experiments />
              </ExperimentsDrawerProvider>
            ),
            loader: experimentsLoader,
          },
          {
            path: `${Matches.EXPERIMENT_ID}/variants`,
            element: <ExperimentVariants />,
            loader: experimentVariantsLoader,
          },
          {
            path: `${Matches.EXPERIMENT_ID}/results`,
            element: <ExperimentResults />,
            loader: experimentResultsLoader,
          },
        ],
      },
      {
        path: "questions",
        children: [
          {
            index: true,
            element: <Questions />,
            loader: questionsLoader,
          },
        ],
      },
      {
        path: "question-options",
        element: <QuestionOptions />,
        loader: questionOptionsLoader,
      },
      {
        path: "products",
        children: [
          {
            index: true,
            loader: productsLoader,
            element: (
              <ItemsSelectionProvider>
                <ProductsDrawerProvider>
                  <Products />
                </ProductsDrawerProvider>
              </ItemsSelectionProvider>
            ),
          },
          {
            path: Matches.PRODUCT_ID,
            element: <ProductDetailsMenu />,
            loader: productLoader,
            children: [
              {
                path: Paths.PRICES,
                children: [
                  {
                    index: true,
                    element: (
                      <PricesDrawerProvider>
                        <ProductPrices />
                      </PricesDrawerProvider>
                    ),
                    loader: pricesLoader,
                  },
                  {
                    path: Matches.PRICE_ID,
                    element: <PriceDetails />,
                    loader: priceLoader,
                  },
                ],
              },
              ...intakesPath,
              {
                path: Paths.PRODUCT_MEDICATIONS,
                children: [
                  {
                    index: true,
                    element: (
                      <MedicationsDrawerProvider>
                        <ProductMedications />
                      </MedicationsDrawerProvider>
                    ),
                    loader: medicationsLoader,
                  },
                  {
                    path: Matches.MEDICATION_ID,
                    element: <ProductMedicationDetails />,
                    loader: medicationLoader,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "provider-availability",
        children: [
          {
            index: true,
            element: <ProvidersAvailability />,
          },
          {
            path: Matches.AVAILABILITY_ID,
            element: <ProviderAvailabilityDetail />,
          },
        ],
      },
      {
        path: "employees",
        children: [
          {
            index: true,
            element: <Employees />,
          },
          {
            path: Matches.EMPLOYEE_ID,
            element: (
              <MasonryLayoutProvider>
                <Employee />
              </MasonryLayoutProvider>
            ),
            loader: employeeLoader,
          },
        ],
      },
    ],
  },
];
